import { useSinglePriceTicker } from '@features/dashboard/widgets/watchlist/hooks/SinglePriceTicker';
import { Typography } from '@mui/material';
import { Product, ProductTenor } from '@protos/product';

export interface SimplePriceTickerProps {
  product: Product | null;
  tenor: ProductTenor | null;
  frontTenor: ProductTenor | null;
  backTenor: ProductTenor | null;
}

export const SimplePriceTicker = (props: SimplePriceTickerProps) => {
  const { product, tenor, frontTenor, backTenor } = props;

  const { bid, mid, ask } = useSinglePriceTicker(product, tenor, frontTenor, backTenor);

  const bidValue = bid ? bid.toFixed(2) : '-';
  const midValue = mid ? mid.toFixed(2) : '-';
  const askValue = ask ? ask.toFixed(2) : '-';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      <div style={{ flexGrow: 1 }}>
        <Typography
          variant="h6"
          sx={theme => {
            return {
              pointerEvents: 'none',
              color: theme.palette.text.primary,
              textAlign: 'center',
              fontSize: '0.9em',
            };
          }}
        >
          Mid <span>{midValue}</span>
        </Typography>
      </div>

      <div style={{ display: 'flex', flexGrow: 1, padding: '1em', transition: 'all 0.2s ease', flexDirection: 'row', flexWrap: 'wrap' }}>
        <div style={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            sx={theme => {
              return {
                pointerEvents: 'none',
                color: theme.palette.background.buy,
                textAlign: 'center',
                fontSize: '0.9em',
              };
            }}
          >
            Bid <span>{bidValue}</span>
          </Typography>
        </div>

        <div style={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            sx={theme => {
              return {
                pointerEvents: 'none',
                color: theme.palette.background.sell,
                textAlign: 'center',
                fontSize: '0.9em',
              };
            }}
          >
            Ask <span>{askValue}</span>
          </Typography>
        </div>
      </div>
    </div>
  );
};
